import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import get from 'lodash/get';

/**
 * Blocks the routes this app no longer serves as the shutdown progresses.
 *
 * Two levels. With only creation disabled (LAU-142) the dashboard is otherwise
 * intact and just Upgrades is closed. Payout-only mode (LAU-53) reduces the app
 * to Home.
 *
 * Payouts and Settings are Rails-served, so Home is the only surviving page
 * here. Everything else returns the creator to Home, matching where sign-in
 * puts them and what the Rails gate does for its own blocked routes.
 *
 * This is a guard, not a deletion: with the mode off every route behaves
 * exactly as before, so a rollback is a flag flip rather than a revert.
 */
export const PAYOUT_ONLY_ALLOWED_PATHS = [/^\/overview\/?$/, /^\/404\/?$/];

// Closed as soon as creation is disabled, while everything else still works.
export const CREATION_DISABLED_PATHS = [/^\/upgrades\/?$/];

export const HOME_PATH = '/overview';

const PayoutOnlyModeGuard = () => {
  const payoutOnlyMode = useSelector((state) =>
    get(state, 'header.user.payoutOnlyMode', false)
  );
  const creationDisabled = useSelector((state) =>
    get(state, 'header.user.creationDisabled', false)
  );
  const { pathname } = useLocation();

  // Payout-only mode is a superset, so it is checked first.
  if (payoutOnlyMode) {
    return PAYOUT_ONLY_ALLOWED_PATHS.some((allowed) =>
      allowed.test(pathname)
    ) ? null : (
      <Redirect to={HOME_PATH} />
    );
  }

  if (
    creationDisabled &&
    CREATION_DISABLED_PATHS.some((b) => b.test(pathname))
  ) {
    return <Redirect to={HOME_PATH} />;
  }

  return null;
};

export default PayoutOnlyModeGuard;
